export const orderEventTypes = <T extends { id: string }>(
	eventTypes: T[],
	orderedIds: string[] | undefined | null,
): T[] => {
	if (!orderedIds?.length) return eventTypes

	const byId = new Map(eventTypes.map((e) => [e.id, e]))
	const idsSet = new Set(orderedIds)

	const ordered = orderedIds
		.map((id) => byId.get(id))
		.filter((e): e is T => !!e)

	const missing = eventTypes.filter((e) => !idsSet.has(e.id))

	return [...ordered, ...missing]
}
